import styled from "@emotion/styled";
export const StyledSubscribeButton = styled.div``;
